import { User, Branch, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { SalePriceType } from "../../catalog/model/sale-price-type.model";
import { CustomerAddress, Customer } from "../../parties/model/customer.model";
import { SaleMethodBranchModel } from "../../sales/model/sale-method-branch.model";
import { TableRead } from "../../salons/model/salon.model";
import { InvoiceEntry, InvoiceChangesLookup, DriverAssignment, InvoiceItem, InvoiceItemAdditive, InvoiceItemDescription } from "./invoice.model";
import { ReceiptPaymentModel } from "./receiptpayment.model";
import { DepositHistoryModel } from "../../catalog/model/deposit.model";

export class InvoiceHistory extends EntityBase {
  public InvoiceId?: number;
  public OriginalValue: InvoiceEntry;
  public CommandId?: number;
  public CommandTitle: string;
  public CommandCode?: number;
  public ChangesTitle: string;
  public Changes: InvoiceChangesLookup[];
  public PayableChangeId?: number;
  public PayableChangeTitle: string;
  public PayableChangeCode?: number;
  public NumberOfGuests: number;
  public Description: string;
  public TaxRate: number;
  public TollRate: number;
  public ServiceRate: number;
  public ServiceTax: number;
  public posPaymentIndex: number;
  public ApplyTaxForService: boolean;
  public ApplyTaxForShippingCost: boolean;
  public IgnoreService: boolean;
  public IgnoreShippingCost: boolean;
  public PhoneId?: number;
  public PhoneNumber: string;
  public AddressId?: number;
  public CustomerAddres: string;
  public CustomerAddress: CustomerAddress;
  public Customer: Customer;
  public ShippingCost: number;
  public ShippingCostTax: number;
  public CourierShippingCost: number;
  public StatusId?: number;
  public StatusTitle: string;
  public StatusCode?: number;
  public TotalNet: number;
  public TotalService: number;
  public TotalTax: number;
  public TotalToll: number;
  public Discount: number;
  public TotalDiscount: number;
  public DiscountPrice: number;
  public IsDiscountPercent: boolean;
  public Total: number;
  public WebId?: number;
  public RoundingAmount: number;
  public RoundingTypeId?: number;
  public RoundingTypeTitle: string;
  public RoundingTypeCode?: number;
  public PayableTotal: number;
  public Debit: number;
  public Credit: number;
  public Tip: number;
  public DriverAssingDate?: string;
  public DriverReturnDate?: Date;
  public NumberingInDate: number;
  public User: User;
  public WaiterId?: number;
  public WaiterName: string;
  public CustomerId: number;
  public CustomerLastName: string;
  public CustomerName: string;
  public CustomerNumber?: number;
  public CustomerDisplayName: string;
  public TableId?: number;
  public TableTitle: string;
  public SalonTitle: string;
  public TableRead: TableRead;
  public SaleMethodBranch: SaleMethodBranchModel;
  public SaleMethodNatureCode?: number;
  public SaleMethodBranchId: number;
  public SaleMethodBranchTitle: string;
  public CreatedUserName: string;
  public BranchId: number;
  public selected: boolean;
  public ModifiedDateTime: string;
  public ShamsiDateTime: string;
  public DateTime: string;
  public Branch: Branch;
  public SalePriceTypeId: number;
  public SalePriceType: SalePriceType;
  public DriverAssignments: DriverAssignment;
  public ReceiptPayments: ReceiptPaymentModel[];
  public Items: InvoiceItemHistory[];
  public Cleared: boolean;
  public Completed: boolean;
  public Code: number;
  public TabId: string;
  public SaleMethodId: number;
  public PaymentMethodTypeId: number;
  public PaymentMethodTypeIndex: number;
  public HasChange: boolean;
  public SalonId?: number;
  public Command: Lookup;
  public Status: Lookup;
  public DeliveryCustomerPrintTimeCode: number;
  public PreparationPrintCount: number;
  public CustomerPrintCount: number;
  public LastInvoiceCode: number;
  public LastInvoiceAmount: number;
  public SettlementId: number;
  public HasLocalPrtinter: boolean;
  public FiscalYearId: number;
  public Year?: number;
  public SettlementRefrenceCode: number;
  public IsValidRemain?: boolean;
  public PackingPrice: number;
  public DepositHistory: DepositHistoryModel;
  SalePriceTypeTitle: string;
  public ClearedUserId?: number;
  public DiscountType?: number;
  public ClearedUserName?: string;
  constructor() {
    super();
    this.TotalToll = 0;
    this.SalePriceTypeTitle = "";
    this.Id = 0;
    this.SettlementRefrenceCode = null;
    this.IsValidRemain = null;
    this.SettlementId = null;
    this.HasLocalPrtinter = null;
    this.FiscalYearId = null;
    this.Year = null;
    this.HasChange = null;
    this.SalonId = null;
    this.DeliveryCustomerPrintTimeCode = null;
    this.PreparationPrintCount = null;
    this.LastInvoiceCode = null;
    this.SaleMethodId = null;
    this.PaymentMethodTypeId = null;
    this.PaymentMethodTypeIndex = null;
    this.TableRead = null;
    this.SaleMethodBranch = null;
    this.SaleMethodNatureCode = null;
    this.SaleMethodBranchTitle = null;
    this.ModifiedDateTime = null;
    this.ShamsiDateTime = null;
    this.DriverAssignments = null;
    this.ModifiedDateTime = null;
    this.DateTime = null;
    this.SalonTitle = "";
    this.TableTitle = "";
    this.CustomerDisplayName = "";
    this.CustomerLastName = "";
    this.WaiterName = "";
    this.LastInvoiceAmount = 0;
    this.DiscountPrice = 0;
    this.OriginalValue = null;
    this.CreatedUserName = "";
    this.CommandId = null;
    this.CommandTitle = "";
    this.CommandCode = 0;
    this.Changes = [];
    this.PayableChangeId = null;
    this.PayableChangeTitle = "";
    this.PayableChangeCode = null;
    this.NumberOfGuests = 0;
    this.Description = "";
    this.TaxRate = 0;
    this.TollRate = 0;
    this.ServiceRate = 0;
    this.ServiceTax = 0;
    this.ApplyTaxForService = false;
    this.ApplyTaxForShippingCost = false;
    this.IgnoreService = false;
    this.IgnoreShippingCost = false;
    this.IsDiscountPercent = true;
    this.PhoneId = null;
    this.PhoneNumber = "";
    this.AddressId = null;
    this.CustomerAddress = null;
    this.CustomerAddres = "";
    this.ShippingCost = 0;
    this.ShippingCostTax = 0;
    this.CourierShippingCost = 0;
    this.StatusId = null;
    this.StatusTitle = "";
    this.StatusCode = 0;
    this.TotalNet = 0;
    this.TotalService = null;
    this.TotalTax = 0;
    this.Discount = 0;
    this.TotalDiscount = 0;
    this.Total = 0;
    this.RoundingAmount = 0;
    this.RoundingTypeId = null;
    this.RoundingTypeTitle = "";
    this.RoundingTypeCode = null;
    this.PayableTotal = 0;
    this.Debit = 0;
    this.Credit = 0;
    this.Tip = 0;
    this.DriverAssingDate = null;
    this.InvoiceId = null;
    this.DriverReturnDate = null;
    this.NumberingInDate = 0;
    this.WaiterId = null;
    this.CustomerId = 0;
    this.CustomerName = "";
    this.CustomerNumber = null;
    this.TableId = null;
    this.SaleMethodBranchId = 0;
    this.BranchId = 0;
    this.SalePriceTypeId = 0;
    this.ReceiptPayments = [];
    this.Items = [];
    this.Cleared = false;
    this.Completed = false;
    this.Code = 0;
    this.TabId = "";
    this.CustomerPrintCount = 0;
    this.PreparationPrintCount = 0;
    this.PackingPrice = 0;
    this.posPaymentIndex = null;
    this.Branch = new Branch();
    this.DepositHistory = new DepositHistoryModel();
    this.ClearedUserId = 0;
    this.ClearedUserName = "";
  }
}
export class InvoiceItemHistory extends EntityBase {
  public Index: number;
  public Quantity: number;
  public QuantityUp: boolean;
  public QuantityDown: boolean;
  public DescriptionChange: boolean;
  public Free: boolean;
  public UnitPrice: number;
  public Price: number;
  public TotalPrice: number;
  public TotalPriceUp: boolean;
  public TotalPriceDown: boolean;
  public ItemTotal: number;
  public UnitDiscount: number;
  public AdditiveUnitDiscount: number;
  public AdditiveServiceUnitDiscount: number;
  public TotalDiscount: number;
  public RowDiscountPrice: number;
  public RowDiscountPriceUP: boolean;
  public RowDiscountPriceDown: boolean;
  public UnitService: number;
  public UnitTax: number;
  public UnitToll: number;
  public UnitAdditive: number;
  public UnitAdditiveApplyTaxPrice: number;
  public UnitAdditiveServicePrice: number;
  public UnitAdditiveRowDiscountPrice: number;
  public Description: string;
  public ApplyService: boolean;
  public ApplyTax: boolean;
  public ItemId: number;
  public ItemTitle: string;
  //public Item: Item;
  public InvoiceId: number;
  public CategoryId?: number;
  public ParentCategoryId?: number;
  public GoodsId?: number;
  public IsDependent: boolean;
  public Ingredients: string;
  public Ingredients_En: string;
  public Additives: InvoiceItemAdditive[];
  public Descriptions: InvoiceItemDescription[];
  public Tax: number;
  public Toll: number;
  public Service: number;
  public PackingPrice: number;
  public RowDiscount: number;
  public additivePrice: number;
  public showPercent: boolean;

  constructor() {
    super();
    this.Index = 0;
    this.AdditiveUnitDiscount = 0;
    this.UnitAdditiveRowDiscountPrice = 0;
    this.additivePrice = 0;
    this.Quantity = 0;
    this.Free = false;
    this.TotalPrice = 0;
    this.UnitPrice = 0;
    this.UnitDiscount = 0;
    this.RowDiscountPrice = 0;
    this.UnitService = 0;
    this.UnitTax = 0;
    this.UnitToll = 0;
    this.UnitAdditive = 0;
    this.Description = "";
    this.ApplyService = false;
    this.ApplyTax = false;
    this.ItemId = 0;
    // this.Item = new Item();
    this.InvoiceId = 0;
    this.Additives = [];
    this.Descriptions = [];
    this.IsDependent = false;
    this.Tax = 0;
    this.Toll = 0;
    this.PackingPrice = 0;
    this.RowDiscount = 0;
    this.RowDiscountPrice = 0;
  }
}
export class InvoiceHistoryCompare extends InvoiceHistory {
  TotalTaxup: boolean;
  TotalTaxDown: boolean;
  TotalServiceup: boolean;
  TotalServiceDown: boolean;
  TotalDiscountup: boolean;
  TotalDiscountDown: boolean;
  ShippingCostup: boolean;
  ShippingCostDown: boolean;
  PackingPriceup: boolean;
  PackingPriceDown: boolean;
  PayableTotalup: boolean;
  PayableTotalDown: boolean;
  Totalup: boolean;
  TotalDown: boolean;
  Debitup: boolean;
  DebitDown: boolean;
  Creditup: boolean;
  CreditDown: boolean;
  DescriptionChange: boolean;
}
